var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D753183A-4AE9-4811-8927-F6A79767E4AC@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Elements",
    transform: "translate(-164.000000, -456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/24/delivery/waitingToLoadAtPlant",
    transform: "translate(164.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_status"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B2C3C9",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,19.4882812 C14.0625,19.4882812 15.8261719,18.7558594 17.2910156,17.2910156 C18.7558594,15.8261719 19.4882812,14.0625 19.4882812,12 C19.4882812,9.9375 18.7558594,8.17382812 17.2910156,6.70898438 C15.8261719,5.24414062 14.0625,4.51171875 12,4.51171875 C9.9375,4.51171875 8.16796875,5.25 6.69140625,6.7265625 C5.23828125,8.1796875 4.51171875,9.9375 4.51171875,12 C4.51171875,14.0625 5.24414062,15.8261719 6.70898438,17.2910156 C8.17382812,18.7558594 9.9375,19.4882812 12,19.4882812 Z M12,18.0117188 C10.359375,18.0117188 8.94140625,17.4257812 7.74609375,16.2539062 C6.57421875,15.0585938 5.98828125,13.640625 5.98828125,12 C5.98828125,10.359375 6.58007812,8.94726562 7.76367188,7.76367188 C8.94726562,6.58007812 10.359375,5.98828125 12,5.98828125 C13.640625,5.98828125 15.0527344,6.58007812 16.2363281,7.76367188 C17.4199219,8.94726562 18.0117188,10.359375 18.0117188,12 C18.0117188,13.640625 17.4199219,15.0527344 16.2363281,16.2363281 C15.0527344,17.4199219 13.640625,18.0117188 12,18.0117188 Z M12.0351562,16.5 C13.2773438,16.5 14.3320312,16.0546875 15.1992188,15.1640625 C16.0664062,14.2734375 16.5,13.21875 16.5,12 C16.5,10.78125 16.0546875,9.7265625 15.1640625,8.8359375 C14.2734375,7.9453125 13.21875,7.5 12,7.5 L12,7.5 L12,12 L8.8359375,15.1640625 C9.7265625,16.0546875 10.7929688,16.5 12.0351562,16.5 Z",
    id: "\\uE422",
    fillOpacity: 0.96,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.df24822f2be0775c86ce8b4378054aa6.svg";
export { ForwardRef as ReactComponent };